/**
 * The first-time path (Stage 8, Sam 2026-10-23: "before the click is more important than after"): instead of a tutorial,
 * the next thing a new person should tap glows - the new group's Invite glow (.invite-nudge), the same everywhere - until
 * they have done it once on this phone, then never again:
 *
 *   rsvp   the event's Join
 *   group  Create a Group (in How do you want to go?)
 *   invite a new group's Invite (GroupInfoPanel's own highlightInvite)
 *   pick   Sets on a group or event, then the first set's + on the Sets page
 *   track  the first person in Find's list
 *
 *   const glow = useNudge('pick', hasLineup);   // className, '' once done or when the step does not apply
 *   markDone('pick');                            // where the step happens
 *
 * Remembered per device (prii.done.<step>). ?nudges=again in a dev build shows every step's glow again.
 */
import { useSyncExternalStore } from 'react';

const KEY = (step) => `prii.done.${step}`;
const listeners = new Set();
const again = () =>
  import.meta.env.DEV &&
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('nudges') === 'again';

export function isDone(step) {
  if (again()) return false;
  try {
    return window.localStorage.getItem(KEY(step)) === '1';
  } catch {
    return true;
  } // no storage: never nag
}
export function markDone(step) {
  try {
    if (window.localStorage.getItem(KEY(step)) === '1') return;
    window.localStorage.setItem(KEY(step), '1');
  } catch {
    /* private mode */
  }
  for (const fn of listeners) fn();
}
const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

/** The glow's className while `step` is not done and applies here (`when`), else ''. */
export function useNudge(step, when = true) {
  const done = useSyncExternalStore(
    subscribe,
    () => isDone(step),
    () => true,
  );
  return when && !done ? 'invite-nudge' : '';
}
